import { AnaColumn } from "../forms-template.service";

export const creaRegistroRentri: AnaColumn[] = [
  {
    itemType: "group", colCount: "2", class: "", captionClass: 'd-none', colGroup: 7, caption: "",
    data: [
      {
        type: 'campo',
        dataField: 'unitaLocale',
        colVisible: true,
        disabled: true,
        disableOnUpdate: true,
        class: 'opacity-100',
        dataType: 'string',
        nCol: 6,
        caption: 'Unità Locale',
      },
      { type: 'empty' },

      {
        type: 'campo',
        dataField: 'num_iscr_sito',
        colVisible: true,
        nCol: 4,
        disabled: true,
        disableOnUpdate: true,
        class: 'opacity-100',
        dataType: 'string',
        caption: 'Allineamento U.L',
      },
      { type: 'empty' },

      {
        type: 'campo',
        dataField: 'registroRentri',
        colVisible: true,
        disabled: true,
        nCol: 3,
        disableOnUpdate: true,
        class: 'opacity-100',
        dataType: 'string',
        caption: 'ID Rentri',
      },
      {
        type: 'campo',
        dataField: 'numero_movimenti',
        nCol: 2,
        colVisible: true,
        disabled: true,
        disableOnUpdate: true,
        class: 'opacity-100',
        dataType: 'number',
        caption: 'Totale Movimenti',
        editorType: 'dxNumberBox',
        // defaultValue: '0'
      },
      {
        type: 'campo',
        dataField: 'ultimo_progressivo',
        nCol: 3,
        colVisible: true,
        disabled: true,
        disableOnUpdate: true,
        class: 'opacity-100',
        dataType: 'string',
        caption: 'Ulitimo prog. movimento Rentri',
        labelWidth: 200
      },
      {
        type: 'campo',
        dataField: 'data_ora_registrazione_ultimo_movimento',
        nCol: 3,
        colVisible: true,
        disabled: true,
        disableOnUpdate: true,
        dataType: 'date',
        class: 'opacity-100',
        caption: 'Data ultimo movimento Rentri',
        editorType: 'dxDateBox',
        // defaultValue: '0'
      },



      {
        type: 'campo',
        dataField: 'descrizione',
        nCol: 6,
        colVisible: true,
        disabled: true,
        disableOnUpdate: true,
        class: 'opacity-100',
        dataType: 'string',
        caption: 'Descrizione',
      },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'attivita',
        colVisible: true,
        dataType: 'string',
        visible: false,
        caption: 'Tipo Attività',
        editorType: 'dxSelectBox',
      },

      {
        type: 'campo',
        dataField: 'attivita_rec_smalt',
        colVisible: true,
        visible: false,
        dataType: 'string',
        caption: 'attivita_rec_smalt',
        // OperazioneSmaltimento
      },
    ]
  },
  {
    itemType: "group", colCount: "3", class: "justify-content-center gap-3", caption: "", captionClass: 'd-none',
    data: [
      {
        type: 'campo',
        editorType: 'dxSelectBox',
        labelVisible: false,
        dataField: 'listaAttivita',
        class: '',
        nCol: 4,
        height: 390,
        caption: 'Tipo Attivita',
        lista: {
          related: ['attivita'],
          Async: false,
          dataSource: '',
          valueExpr: 'key',
          displayExpr: 'value',
          keyExpr: 'key',
          static: true,
          isMultiple: true,
          showSelectionControls: true,
          isDefaultOption: false,
          tipoSelect: 'multiple',
          items: [],
          isUnselected: false,
        },
      },
      {
        type: 'campo',
        dataField: 'listaRecupero',
        editorType: 'dxSelectBox',
        labelVisible: false,
        caption: 'Recupero',
        class: 'statImpostazioni',
        nCol: 4,
        height: 390,
        lista: {
          Async: false,
          dataSource: '',
          valueExpr: 'code',
          displayExpr: 'code',
          keyExpr: 'code',
          static: true,
          isMultiple: true,
          showSelectionControls: true,
          isDefaultOption: false,
          tipoSelect: 'multiple',
          items: [],
          isUnselected: false,
        },
      },
      {
        type: 'campo',
        dataField: 'listaSmaltimento',
        editorType: 'dxSelectBox',
        labelVisible: false,
        caption: 'Smaltimento',
        height: 390,
        nCol: 4,
        lista: {
          Async: false,
          dataSource: '',
          valueExpr: 'code',
          displayExpr: 'code',
          keyExpr: 'code',
          static: true,
          isMultiple: true,
          showSelectionControls: true,
          isDefaultOption: false,
          tipoSelect: 'multiple',
          items: [],
          isUnselected: false,
        },
      },
    ]
  }
]